import React, {PropTypes} from 'react';

function baseToggleChangeHandler(event) {
    const value = this.props.children;

    this.props.onChange(value, event);
}

class BaseToggle extends React.Component {
    static displayName = 'BaseToggle';

    static propTypes = {
        children: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        icon: PropTypes.element.isRequired,
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        selected: PropTypes.bool.isRequired,
        type: PropTypes.oneOf(['checkbox', 'radio'])
    };

    render() {
        const
            {disabled, children, className, icon, id, selected, type, name} = this.props;
        const defaultName = name || id;

        return (
            <div>
                <input
                    checked={selected}
                    className={className}
                    disabled={disabled}
                    id={id}
                    name={defaultName}
                    onChange={baseToggleChangeHandler.bind(this)}
                    type={type}
                />
                <label
                    className='with-icon'
                    htmlFor={id}
                    title={children}
                >
                    {icon}
                    <span>
                        {children}
                    </span>
                </label>
            </div>
        );
    }
}

export default BaseToggle;



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/src/base-toggle.js